var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconPrev = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 12,
  height: 12,
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Isolation_Mode",
  clipPath: "url(#clip0_3896_5568)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  d: "M1.01363 6.46662C0.829784 6.28277 0.723717 6.03528 0.716646 5.75951C0.716646 5.20797 1.16212 4.76249 1.71367 4.76249L10.206 4.75542C10.7576 4.75542 11.203 5.2009 11.203 5.75244C11.203 6.30398 10.7576 6.74946 10.206 6.74946L1.72074 6.7636C1.4379 6.7636 1.19748 6.65046 1.01363 6.46662Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_2",
  d: "M4.54916 10.002L1.01363 6.46642C0.624722 6.07752 0.624721 5.44112 1.01363 5.05221L4.54916 1.51668C4.93807 1.12777 5.57447 1.12777 5.96338 1.51668C6.35229 1.90559 6.35229 2.54198 5.96338 2.93089L3.13495 5.75932L5.96338 8.58774C6.35229 8.97665 6.35229 9.61305 5.96338 10.002C5.57447 10.3909 4.93807 10.3909 4.54916 10.002Z",
  fill: "white"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_3896_5568"
}, /*#__PURE__*/React.createElement("rect", {
  width: 8,
  height: 8,
  fill: "white",
  transform: "translate(5.96338 0.102539) rotate(45)"
})))));
export default SvgIconPrev;